import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { ExpenseCategoryDTO, ExpenseCategoryRequest } from '../interfaces/expense.interface';

interface PagedResponse<T> {
    content: T[];
    totalElements: number;
    totalPages: number;
    number: number;
    size: number;
}

export const ExpenseCategoryService = {
    listByInstitution: async (page = 0, size = 50): Promise<PagedResponse<ExpenseCategoryDTO>> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.EXPENSE_CATEGORY.LIST_BY_INSTITUTION(institutionId), {
            params: { page, size },
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    create: async (req: Omit<ExpenseCategoryRequest, 'institutionId'>): Promise<ExpenseCategoryDTO> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.post(ENDPOINTS.EXPENSE_CATEGORY.CREATE, { ...req, institutionId }, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    update: async (id: string, req: Omit<ExpenseCategoryRequest, 'institutionId'>): Promise<ExpenseCategoryDTO> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.put(ENDPOINTS.EXPENSE_CATEGORY.UPDATE(id), { ...req, institutionId }, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    delete: async (id: string): Promise<void> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        await axios.delete(ENDPOINTS.EXPENSE_CATEGORY.DELETE(id, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
    },
};
